import React from 'react';
import { Box } from '@common-fe/common-fe';

import { PaymentMethod } from '@/modules/employee/employee.types';
import { PaymentMethodLabel } from '@/modules/ReimburseMe/ConfirmationStep/Immediately/PaymentMethodLabel';

interface Props {
  paymentMethod?: PaymentMethod;
  paymentEmployeeFee?: string;
}

const PaymentMethodField: React.FC<Props> = ({ paymentMethod, paymentEmployeeFee }) => (
  <Box style={{ position: 'relative' }}>
    <PaymentMethodLabel paymentMethod={paymentMethod} paymentEmployeeFee={paymentEmployeeFee} />
  </Box>
);

export default PaymentMethodField;
